var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"calc(100vh - 64px)","padding-bottom":"0"},attrs:{"id":"graphiql"}})}
var staticRenderFns = []

export { render, staticRenderFns }